'use strict';

const SELECTOR = '.piece-notes';
const TAB_SELECTOR = '[role="tab"]';

export function initialiseElement(element) {
    if (!SELECTOR) return;

    element.addEventListener('click', function (event) {
        const tab = event.target.closest(TAB_SELECTOR);
        if (!tab) return;
        if (!element.contains(tab)) return;

        const tablist = tab.closest('[role="tablist"]');
        if (!tablist) return;

        const tabs = tablist.querySelectorAll(TAB_SELECTOR);

        tabs.forEach(function (t) {
            const isActive = t === tab;

            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.classList.toggle('is-active', isActive);

            const panelId = t.getAttribute('aria-controls');
            if (!panelId) return;

            const panel = element.querySelector('#' + panelId);
            if (!panel) return;

            panel.hidden = !isActive;
            panel.setAttribute('aria-live', 'polite');
        });
    });
}

export default function () {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}
